import { Dataset, GridRow } from '../../../types/types';
import { ExportSection } from '../types';
import { resolveExportColumns } from './resolveExportColumns';

interface DatasetSubset {
  datasetId?: string;
  label?: string;
}

export const buildExportSections = (
  dataset: Dataset | undefined,
  rows: GridRow[],
  slaveDatasets: Record<string, Dataset>
): ExportSection[] => {
  if (!dataset?.datasetId) {
    return [];
  }

  const subsets: DatasetSubset[] = Array.isArray(dataset.subsets)
    ? dataset.subsets
    : [];

  return [
    {
      id: dataset.datasetId,
      label: dataset.label,
      kind: 'master',
      enabled: true,
      columns: resolveExportColumns(dataset.items, true, dataset.idItem),
      rows,
      dataAvailable: rows.length > 0,
    },
    ...subsets.map<ExportSection>((subset) => {
      const subsetId = subset.datasetId ?? '';
      const slaveDataset = slaveDatasets[subsetId];

      return {
        id: subsetId,
        label: subset.label ?? slaveDataset?.label ?? subsetId,
        kind: 'subset',
        enabled: false,
        columns: resolveExportColumns(
          slaveDataset?.items,
          true,
          slaveDataset?.idItem
        ),
        rows: [],
        // Prototype keeps subset definitions selectable; real rows require API paging by master row.
        dataAvailable: false,
      };
    }),
  ];
};
